import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

export default function VehicleSparepartsTable() {
  const navigate = useNavigate();

  const handleNavigate = (vehicleno) => {
    navigate(`/${vehicleno}`);
  };

  const data = [
    { id: 1, vehicleno: "MH20ER4534", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
    { id: 2, vehicleno: "Uber Vehicle", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
    { id: 3, vehicleno: "MH03AS3945", spareparts: "Side Mirror", warranty: "24", quantity: "1", amount: "$1200" },
    { id: 4, vehicleno: "MH04KL0921", spareparts: "Side Mirror", warranty: "45", quantity: "1", amount: "$1200" },
    { id: 5, vehicleno: "MH05MH5932", spareparts: "Side Mirror", warranty: "44", quantity: "5", amount: "$1200" },
    { id: 6, vehicleno: "MH06MJ4321", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
    { id: 7, vehicleno: "MH07ND4567", spareparts: "Side Mirror", warranty: "5", quantity: "2", amount: "$1200" },
    { id: 8, vehicleno: "MH08KK4909", spareparts: "Side Mirror", warranty: "3", quantity: "2", amount: "$1200" },
    { id: 9, vehicleno: "MH11KL0008", spareparts: "Side Mirror", warranty: "11", quantity: "2", amount: "$1200" },
    { id: 10, vehicleno: "MH20UI3424", spareparts: "Side Mirror", warranty: "12", quantity: "2", amount: "$1200" },
    { id: 11, vehicleno: "MH20SQ9021", spareparts: "Seat Cover", warranty: "34", quantity: "2", amount: "$1200" },
    { id: 12, vehicleno: "MH23MK8245", spareparts: "Cluch Wire", warranty: "13", quantity: "2", amount: "$1200" },
    { id: 13, vehicleno: "MH24NF5321", spareparts: "Break Linear", warranty: "55", quantity: "4", amount: "$1200" },
    { id: 14, vehicleno: "MH22PQ4441", spareparts: "Engine Oil", warranty: "12", quantity: "2", amount: "$1200" },
    { id: 15, vehicleno: "MH12EE2323", spareparts: "Battery", warranty: "34", quantity: "5", amount: "$1200" },
    { id: 16, vehicleno: "MH11FG9090", spareparts: "Oil Seal", warranty: "6", quantity: "1", amount: "$1200" },
    { id: 17, vehicleno: "MH20UI1221", spareparts: "Speed Meter", warranty: "9", quantity: "1", amount: "$1200" },
    { id: 18, vehicleno: "MH20EE0890", spareparts: "Tyer", warranty: "22", quantity: "1", amount: "$1200" },
    { id: 19, vehicleno: "MH20SQ0987", spareparts: "Side Mirror", warranty: "21", quantity: "2", amount: "$1200" },
    { id: 20, vehicleno: "MH21XQ0087", spareparts: "Side Mirror", warranty: "21", quantity: "2", amount: "$1200" },
  ];

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Spareparts</h4>
        <div className="yc-header-actions">
          <Link to="/accountant/createvehiclespareparts" className="btn btn-primary">
            Create Vehicle Spareparts
          </Link>
          <div className="dropdown">
            <button
              id="btnGroupDropExport"
              type="button"
              className="btn btn-primary dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Export
            </button>
            <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
              <li><a className="dropdown-item" href="#">Save as PDF</a></li>
              <li><a className="dropdown-item" href="#">Save as PNG</a></li>
              <li><a className="dropdown-item" href="#">Save as CSV</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select className="form-select">
            <option>All</option>
            <option>MH20EE3948</option>
            <option>MH21RE4890</option>
          </select>
          <input type="text" className="form-control" placeholder="SpareParts" />
          <button type="button" className="btn btn-primary">Clear</button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-7">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Vehicle Number/Name</div>
            <div className="yc-list-cell">Spareparts</div>
            <div className="yc-list-cell">Warranty</div>
            <div className="yc-list-cell">Quantity</div>
            <div className="yc-list-cell">Amount</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        <div className="yc-list-row-list">
          {data.map((row, idx) => (
            <div key={`${row.id}-${idx}`} className="yc-list-row-card">
              <div className="yc-list-grid yc-list-grid-7">
                <div className="yc-list-cell">{idx + 1}</div>
                <div className="yc-list-cell">{row.vehicleno}</div>
                <div className="yc-list-cell">{row.spareparts}</div>
                <div className="yc-list-cell">{row.warranty}</div>
                <div className="yc-list-cell">{row.quantity}</div>
                <div className="yc-list-cell">{row.amount}</div>
                <div className="yc-list-cell yc-list-cell--actions">
                  <button
                    type="button"
                    className="yc-action-icon"
                    onClick={() => handleNavigate(row.vehicleno)}
                    title="View"
                  >
                    <i className="bi bi-eye"></i>
                  </button>
                  <Link
                    to="/accountant/updatevehicleaccessory"
                    className="yc-action-icon"
                    title="Edit"
                  >
                    <i className="bi bi-pencil-square"></i>
                  </Link>
                  <button
                    type="button"
                    className="yc-action-icon yc-action-icon--danger"
                    onClick={() => handleNavigate(row.vehicleno)}
                    title="Delete"
                  >
                    <i className="bi bi-trash3"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
